import request from '@/router/axios'

const annualDiffBase = '/api/produce/stock-take/annual-diff'

export function fetchAnnualDiffDashboard(params) {
  return request({
    url: `${annualDiffBase}/dashboard`,
    method: 'get',
    params
  })
}

export function fetchAnnualDiffDetailPage(data) {
  return request({
    url: `${annualDiffBase}/detail/page`,
    method: 'post',
    data
  })
}

export function fetchAnnualDiffSheetDetail(sheetId, params) {
  return request({
    url: `${annualDiffBase}/detail/${sheetId}`,
    method: 'get',
    params
  })
}

export function exportAnnualDiffExcel(data) {
  return request({
    url: `${annualDiffBase}/export`,
    method: 'post',
    data,
    responseType: 'blob'
  })
}

export function fetchAnnualDiffCustomerOptions(params) {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get',
    params
  })
}

export function fetchCargoOptions(params) {
  return request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params
  })
}

export function fetchStoreOptions(params) {
  return request({
    url: '/api/produce/store/select/distinct/pycode',
    method: 'get',
    params
  })
}

export function fetchLocationOptions(params) {
  return request({
    url: '/api/produce/location/select/distinct/pycode',
    method: 'get',
    params
  })
}
